'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _propTypes = require('prop-types');

var _objectEditorEnhancer = require('../../DocEditor/objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _AuthEditor = require('./AuthEditor');

var _AuthEditor2 = _interopRequireDefault(_AuthEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function mergeAuth(empty, target) {
  var res = _ramda2.default.clone(empty);
  _ramda2.default.forEachObjIndexed(function (names, api) {
    _ramda2.default.forEachObjIndexed(function (actions, name) {
      _ramda2.default.forEachObjIndexed(function (auth, action) {
        if (auth && _typeof(_ramda2.default.path([api, name], empty)) === 'object') {
          res = _ramda2.default.assocPath([api, name, action], true, res);
        }
      }, actions);
    }, names);
  }, target);
  return res;
}

var AuthEditor = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  schema: _propTypes.object,
  value: _propTypes.object,
  onChange: _propTypes.func.isRequired
}), (0, _getContext2.default)({
  server: _propTypes.object.isRequired
}), (0, _withProps2.default)(function (_ref) {
  var value = _ref.value;
  return { value: value || { views: {}, routes: {}, streams: {}, prints: {} } };
}), (0, _withState2.default)('emptyAuth', 'setEmptyAuth', { views: {}, routes: {}, streams: {}, prints: {} }), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    var _this = this;

    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      var _props, get, setEmptyAuth, onChange, emptyAuth;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = _this.props, get = _props.server.get, setEmptyAuth = _props.setEmptyAuth, onChange = _props.onChange;
              _context.next = 3;
              return get({ url: '/api/route/emptyAuth' });

            case 3:
              emptyAuth = _context.sent;

              onChange(function (value) {
                return mergeAuth(emptyAuth, value);
              });
              setEmptyAuth(emptyAuth);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}), _objectEditorEnhancer2.default, (0, _exposeProps2.default)(['emptyAuth', 'spliter', 'schema', 'value', 'onChange']))(_AuthEditor2.default);

AuthEditor.displayName = 'AuthEditor';

exports.default = AuthEditor;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/index.js
// module id = 1734
// module chunks = 0